/**
 * Semántica única: producto sin costo (alineada a finanzasReadEngine.contarProductosActivosSinCosto).
 */
export function parsePositiveCosto(value) {
  if (value == null || value === '') return null;
  const n = typeof value === 'number' ? value : parseFloat(String(value).trim().replace(',', '.'));
  if (!Number.isFinite(n) || n <= 0) return null;
  return n;
}

/** Misma definición backend: precio_costo ?? costo ?? costo_unitario > 0 */
export function productoTieneCosto(producto) {
  return parsePositiveCosto(
    producto?.precio_costo ?? producto?.costo ?? producto?.costo_unitario
  ) != null;
}

export function productoSinCosto(producto) {
  if (!producto || producto.activo === false) return false;
  return !productoTieneCosto(producto);
}

export const FILTRO_PRODUCTOS_SIN_COSTO = 'sin-costo';
